export interface Bonus {
  id: string
  title: string
  subtitle: string
  bulletsLabel?: string
  bullets: string[]
  flowLabel?: string
  flow?: string[]
  closing?: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'MMA Coaching Cues & Error Correction Handbook',
    subtitle: 'Know what to observe, what to say and how to correct it.',
    bulletsLabel: 'Includes practical coaching cues and correction systems for:',
    bullets: [
      'Stance',
      'Movement',
      'Striking',
      'Clinch',
      'Takedowns',
      'Ground control',
      'Scrambles',
      'Transitions',
    ],
    closing: 'Identify faster. Correct faster. Coach clearer.',
  },
  {
    id: '02',
    title: 'MMA Class Planning & Session Structure Guide',
    subtitle: 'Build better 30, 45, 60 and 90-minute MMA sessions.',
    bulletsLabel: 'Learn how to organize:',
    bullets: [
      'Technical blocks',
      'Partner drills',
      'Reactions',
      'Transitions',
      'Controlled application',
      'Mixed-level groups',
      'Weekly structures',
    ],
    closing: 'Plan less. Structure better.',
  },
  {
    id: '03',
    title: 'MMA Athlete Assessment & Progression System',
    subtitle: 'Know where the athlete is — and what should come next.',
    bulletsLabel: 'Assess:',
    bullets: [
      'Stance',
      'Range',
      'Striking',
      'Clinch',
      'Takedowns',
      'Ground',
      'Transitions',
      'Scrambles',
      'Decision-making',
    ],
    flowLabel: 'Development levels:',
    flow: ['Developing', 'Functional', 'Consistent', 'Advanced'],
  },
  {
    id: '04',
    title: 'MMA Sparring Control & Safety Handbook',
    subtitle: 'Make live training develop skill — not chaos.',
    bulletsLabel: 'Includes frameworks for:',
    bullets: [
      'Technical sparring',
      'Positional sparring',
      'Controlled live work',
      'Partner matching',
      'Intensity control',
      'Progression',
      'Start/stop rules',
      'Coach supervision',
    ],
    closing: 'Better control. Better development. Safer sessions.',
  },
  {
    id: '05',
    title: 'MMA Training Problems & Coaching Solutions Manual',
    subtitle: 'When an athlete struggles, know what to look for next.',
    bullets: [],
    flowLabel: 'Real coaching problems organized as:',
    flow: ['Problem', 'Possible cause', 'Observe', 'Correct', 'Regress', 'Progress'],
    closing: 'Designed to help coaches troubleshoot common issues faster.',
  },
]
